import { WritableDraft, current, produce } from 'immer'

import { Message, MessageType } from '../../../common/ai.dictionary'
import { AiState } from '../../ai.state'

export const setStreamingAiResponse = (
  state: AiState,
  { streamingAiResponse }: { streamingAiResponse: boolean }
): AiState =>
  produce(state, (draft: WritableDraft<AiState>) => {
    draft.streamingAiResponse = streamingAiResponse
  })

export const setIsAiInteractionAllowed = (
  state: AiState,
  { isAiInteractionAllowed }: { isAiInteractionAllowed: boolean }
): AiState =>
  produce(state, (draft: WritableDraft<AiState>) => {
    draft.isAiInteractionAllowed = isAiInteractionAllowed
  })

export const setPendingAiResponse = (
  state: AiState,
  { pendingAiResponse }: { pendingAiResponse: boolean }
): AiState =>
  produce(state, (draft: WritableDraft<AiState>) => {
    draft.pendingAiResponse = pendingAiResponse
  })

export const setPendingKeepDraftSave = (
  state: AiState,
  { pendingKeepDraftSave }: { pendingKeepDraftSave: boolean }
): AiState =>
  produce(state, (draft: WritableDraft<AiState>) => {
    draft.pendingKeepDraftSave = pendingKeepDraftSave
  })

export const setPendingDocumentsLoading = (
  state: AiState,
  { pendingDocumentsLoading }: { pendingDocumentsLoading: boolean }
): AiState =>
  produce(state, (draft: WritableDraft<AiState>) => {
    draft.pendingDocumentsLoading = pendingDocumentsLoading
  })

export const setPendingFixErrorResponse = (
  state: AiState,
  { pendingFixErrorResponse }: { pendingFixErrorResponse: boolean }
): AiState =>
  produce(state, (draft: WritableDraft<AiState>) => {
    draft.pendingFixErrorResponse = pendingFixErrorResponse
  })

export const setPendingFixWarningsResponse = (
  state: AiState,
  { pendingFixWarningsResponse }: { pendingFixWarningsResponse: boolean }
): AiState =>
  produce(state, (draft: WritableDraft<AiState>) => {
    draft.pendingFixWarningsResponse = pendingFixWarningsResponse
  })

export const setMinimizedFalse = (state: AiState): AiState =>
  produce(state, (draft: WritableDraft<AiState>) => {
    // draft.minimized = false
    draft.zenMode = true
  })

export const setMinimizedTrue = (state: AiState): AiState =>
  produce(state, (draft: WritableDraft<AiState>) => {
    draft.minimized = true
  })
